import styled from "styled-components"
import Flex from "@irati/ui/src/Flex"

export const TooltipWrapper = styled(Flex)`
  background-color: ${({theme}) => theme.colors.greys.lightest};
  border-top: 1px solid ${({theme}) => theme.colors.greys.lightest};
  border-radius: ${({theme}) => theme.spacing.one};
`

export const PowerbiWrapper = styled(Flex)`
  .powerbiContainer {
    width: 100%;
    height: calc(100vh - 250px);

    @media (max-width: 1700px) {
      height: calc(100vh - 300px);
    }

    @media (max-width: 1650px) {
      height: calc(100vh - 350px);
    }

    @media (max-width: 1600px) {
      height: calc(100vh - 400px);
    }

    @media (max-width: 1500px) {
      height: calc(100vh - 450px);
    }

    @media (max-width: 1400px) {
      height: calc(100vh - 500px);
    }

    @media (max-width: 1350px) {
      height: calc(100vh - 550px);
    }

    @media (max-width: 1200px) {
      height: calc(100vh - 600px);
    }

    @media (max-width: 1100px) {
      height: calc(100vh - 650px);
    }

    @media (max-width: 1000px) {
      height: calc(100vh - 700px);
    }

    iframe {
      border: none;
    }
  }
`
